import { render, staticRenderFns } from "./MiddleContainer.vue?vue&type=template&id=f7b0acc6&scoped=true&"
import script from "./MiddleContainer.vue?vue&type=script&lang=js&"
export * from "./MiddleContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b0acc6",
  null
  
)

export default component.exports